import '@/app/assets/styles/main.scss'

import { createApp } from 'vue'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { useCartStore } from '@/pages/Cart/model/useCart';
import { useUserStore } from '@/entities/user/model/userStore'

import App from './App.vue'
import router from './router'

import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'

async function start() {
  const app = createApp(App)

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  app.use(VueQueryPlugin, { queryClient });
  app.use(createPinia())
  app.use(router)
  app.use(ToastPlugin);
  const userStore = useUserStore()
  userStore.initialize();
  if (userStore.isAuth) {
    useCartStore().sync();
  }
  app.mount('#app')
}

start()
